import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=c561bee4&scoped=true&"
import script from "./PersonSearch.vue?vue&type=script&lang=ts&"
export * from "./PersonSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561bee4",
  null
  
)

export default component.exports